/**
 * 判断dom是否出现在视口中
 * @param {HTMLElement} $dom
 */
export function isInViewport($dom) {
  if (!$dom) return false

  const bRect = $dom.getBoundingClientRect()

  const { height, top, bottom } = bRect
  const viewportHeight = window.innerHeight // 视口高度

  // dom没有显示
  if (height === 0) return false

  // 没有在视口中
  if (bottom < 0 || top > viewportHeight) return false

  // 完全在视口中
  if (
    (viewportHeight - bottom > 0 && top > 0) ||
    (top < 0 && bottom > viewportHeight)
  )
    return true

  // 局部-上部分被隐藏
  let partHeight = 0
  if (top < 0) {
    partHeight = bottom
    // 局部-下部分被隐藏
  } else {
    partHeight = viewportHeight - top
  }

  // 展示部分超过1/2视为真实曝光
  if (partHeight > height * 0.5) return true

  return false
}

/**
 * 函数防抖
 * @param {function} fn
 * @param {number} delay
 */
export function debounce(fn, delay = 100) {
  let timer = null
  let root = window
  if (typeof global === 'object') {
    root = global
  }

  return function(...args) {
    if (timer) {
      root.clearTimeout(timer)
      timer = null
    }

    timer = setTimeout(fn.bind(null, ...args), delay)
  }
}

export function isPC() {
  const userAgentInfo = navigator.userAgent
  const Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  ]
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}
